import { AutoMap } from "@automapper/classes";
import { BaseModel } from "../base/base.model";
import { createMap, forMember, mapFrom, } from '@automapper/core';
import { mapper } from "src/app/infrastructure/infrastructure-services/common/mapper";

export interface ICompanyModel  {
    companyCode: string,
    companyName: string,
    companyAddress: string,
    companyURL: string,
    companyTelephone: string,
    companyFax: string,
    companyEmailId: string,
    delMark: boolean,
    remarks: string,
    isActive: boolean,
    companyDbName: string,
    serviceLayerURL: string,
    apiGatewayURL: string | null,
    sapdbInstance: string | null,
    

}


export class CompanyModel implements ICompanyModel {

    @AutoMap() companyCode: string = "";
    @AutoMap() companyName: string = "";
    @AutoMap() companyAddress: string = "";
    @AutoMap() companyURL: string = "";
    @AutoMap() companyTelephone: string= "";
    @AutoMap() companyFax: string= "";
    @AutoMap() companyEmailId: string= "";
    @AutoMap() delMark: boolean= false;
    @AutoMap() remarks: string= "";
    @AutoMap() isActive: boolean= false;
    @AutoMap() companyDbName: string = "";
    @AutoMap() serviceLayerURL: string= "";
    @AutoMap() apiGatewayURL: string | null= null;
    @AutoMap() sapdbInstance: string| null= null;



}

export interface ICompanyModelSAP {
    CompanyCode: string,





}

export class CompanyModelSAP implements ICompanyModelSAP {
    @AutoMap() CompanyCode!: string;


    constructor() {
        createMap(mapper, CompanyModel, CompanyModelSAP,
            forMember(
                (destination) => (destination.CompanyCode),
                mapFrom((source) => (source.companyCode))
            ),

        );
    }

}

